import {
	trigger,
	animate,
	style,
	transition,
	state,
  query,
  stagger
} from '@angular/animations';


export const customAnimations = [
  trigger('slideInOut', [
    state('1', style({ height: '*' })),
    state('0', style({ height: '0px' })),
    transition('1 <=> 0', animate(200))
  ])
];

export const explainerAnimation = trigger('explainerAnimation', [
  transition('* => *', [
    query('.animate', style({ opacity: 0, transform: 'translateX(-40px)' })),

    query('.animate', stagger('200ms', [
      animate('500ms 0.3s ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
    ])),

    query('.animate', [
      animate(1000, style('*'))
    ])

  ])
]);

export const enterAnimation3 = trigger('enterAnimation3', [
  transition(':enter', [
    style({ transform: 'translateX(-100%)', opacity: 0 }),
    animate('400ms', style({ transform: 'translateX(0)', opacity: 1 }))
  ]),
  transition(':leave', [
    style({ transform: 'translateX(0)', opacity: 1 }),
    animate('400ms', style({ transform: 'translateX(-100%)', opacity: 0 }))
  ])
]);
export const fadeInFadeOutAnimation = trigger(
  'fadeInFadeOutAnimation', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('300ms', style({ opacity: 1 }))
    ]),
    transition(':leave', [
      style({ opacity: 1 }),
      animate('300ms', style({ opacity: 0 }))
    ])
  ]
);
